import { render, staticRenderFns } from "./line-item.vue?vue&type=template&id=3f723db4"
import script from "./line-item.vue?vue&type=script&lang=js"
export * from "./line-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports